import { find } from 'lodash';
import moment from 'moment';
export const getNumByName = (data, type) => {
    const item = find(data, item => item.name.toLowerCase() === type.toLowerCase());
    return Number(item?.value);
};
export const getNumByTime = (data, type) => {
    const item = find(data, item => item.time.toLowerCase() === type.toLowerCase());
    return Number(item?.value);
};
export const getPre7DayParams = (includeTime = true) => {
    const yestodayDate = moment().subtract(1, 'day').format('YYYY-MM-DD');
    const startDate = moment().subtract(7, 'day').format('YYYY-MM-DD');
    // return includeTime ? {
    //   dateEnd: `${yestodayDate} 23:59:59`,
    //   dateStart: `${startDate} 00:00:00`,
    // } : {
    //   dateEnd: yestodayDate,
    //   dateStart: startDate
    // };
    return {
        dateEnd: yestodayDate,
        dateStart: startDate
    };
};
